
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import axios from 'axios';
import { useLogin } from "../../../../contexts/LoginContext";
import { useNavigate } from 'react-router-dom';

export default function PlanosNichos() {
    const navigate = useNavigate();
    const [objPlanos, setObjPlanos] = useState([]);

    const token = localStorage.getItem("token");

    const [hasPlan, setHasPlan] = useState(false);
    const { fetchLogin } = useLogin();


    useEffect(() => {
        const checkHasPlan = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/hasPlan`, {
                headers: {
                    Authorization: token
                }
            });
            if (response.data.status === 200) {
                setHasPlan(true)
            } else {
                setHasPlan(false)
            }
        }
        checkHasPlan()
    }, [token])

    useEffect(() => {
        const getPlanos = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listarPlanos`);

            setObjPlanos(response.data.planos);
        }
        getPlanos();
    }, [])

    const planos = [
        {
            id: objPlanos[0]?.idPlano,
            title: objPlanos[0]?.nome,
            tipo: 'STARTER',
            faturamento: 'Até R$ 6.750',
            descricao: objPlanos[2]?.descricao,
            preco: objPlanos[0]?.valorNovoMensal ? Number(objPlanos[0]?.valorNovoMensal) : 0,
            destaque: false,
            beneficios: [
                'Abertura de CNPJ ou MEI inclusa',
                'Apuração e envio do DAS',
                'Emissor de nota fiscal',
                '1 reunião por ano',
            ],
        },
        {
            id: objPlanos[1]?.idPlano,
            title: objPlanos[1]?.nome,
            tipo: 'BÁSICO',
            faturamento: 'Até R$ 30 mil',
            descricao: objPlanos[2]?.descricao,
            preco: objPlanos[1]?.valorNovoMensal ? Number(objPlanos[1]?.valorNovoMensal) : 0,
            destaque: true,
            beneficios: [
                'Abertura de CNPJ ou MEI inclusa',
                'Obrigações fiscais completas',
                'Pró-labore + 1 colaborador',
                'Declaração de IRPF do sócio',
                '2 reuniões por ano',
            ],
        },
        {
            id: objPlanos[2]?.idPlano,
            title: objPlanos[2]?.nome,
            tipo: 'AVANÇADO',
            faturamento: 'Até R$ 100 mil',
            descricao: objPlanos[2]?.descricao,
            preco: objPlanos[2]?.valorNovoMensal ? Number(objPlanos[2]?.valorNovoMensal) : 0,
            destaque: false,
            beneficios: [
                'Até 2 sócios',
                'Notas ilimitadas pelo emissor',
                'Pró-labore + 2 colaboradores',
                'Reunião mensal e grupo no WhatsApp',
                'Certificado digital incluso',
            ],
        },
        {
            id: objPlanos[3]?.idPlano,
            title: objPlanos[3]?.nome,
            tipo: 'PLUS+',
            faturamento: 'Até R$ 400 mil',
            descricao: objPlanos[2]?.descricao,
            preco: objPlanos[3]?.valorNovoMensal ? Number(objPlanos[3]?.valorNovoMensal) : 0,
            destaque: false,
            beneficios: [
                'Até 3 sócios',
                'Pró-labore + 3 colaboradores',
                'Reunião quinzenal',
                'Planejamento patrimonial com 50% off',
                'Até 50 notas emitidas por nós',
            ],
        },
    ];

    const HandleChoosePlan = (id, title, description, price) => {
        let text = `assinar${title}`;

        if (typeof window.fbq !== "undefined") {
            window.fbq("trackCustom", text);
        }

        if (!token) {
            navigate("/cadastro");
        }

        if (hasPlan) {
            navigate("../Dashboard");
            return;
        } else {
            console.log({ id, title, description, price });
            localStorage.setItem("planoSelecionado", JSON.stringify({ id, title, description, price, periodicity: "mensal", enderecoFiscal: false, total: price }));
            if (token) {
                fetchLogin();
                navigate("../checkout");
            } else {
                navigate("/cadastro");
            }
            return;
        }

    }


    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: '#171821',
                py: { xs: 7, sm: 8, md: 10 },
                px: { xs: 2, sm: 4, md: 6 },
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    maxWidth: '1100px',
                    margin: '0 auto',
                }}
            >
                {/* Cabeçalho */}
                <Box
                    sx={{
                        mb: { xs: 4, md: 5 },
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '12px',
                            fontWeight: 600,
                            letterSpacing: '3px',
                            color: '#1EFF86',
                            mb: 1,
                        }}
                    >
                        PLANOS
                    </Typography>

                    <Typography
                        component="h2"
                        sx={{
                            fontSize: {
                                xs: '30px',
                                sm: '38px',
                                md: '38px',
                            },
                            lineHeight: 1.05,
                            fontWeight: 800,
                            letterSpacing: '-1.5px',
                            color: '#FFFFFF',
                            mb: 1.5,
                        }}
                    >
                        A contabilidade que cresce junto
                    </Typography>

                    <Typography
                        sx={{
                            maxWidth: '600px',
                            fontSize: {
                                xs: '14px',
                                sm: '15px',
                            },
                            lineHeight: 1.5,
                            color: '#9CA3AF',
                        }}
                    >
                        Escolha pela sua faixa de faturamento mensal, não pelo preço.
                        Quando você sobe de faixa, a gente sobe junto.
                    </Typography>
                </Box>

                {/* Cards */}
                <Box
                    sx={{
                        width: "100%",
                        minWidth: 0,

                        // Desktop
                        display: {
                            xs: "flex",
                            sm: "grid",
                        },

                        gridTemplateColumns: {
                            sm: "repeat(2, minmax(0, 1fr))",
                            lg: "repeat(4, minmax(0, 1fr))",
                        },

                        gap: {
                            xs: 2,
                            md: 1.5,
                        },

                        alignItems: "stretch",

                        // MOBILE CAROUSEL
                        overflowX: {
                            xs: "auto",
                            sm: "visible",
                        },

                        overflowY: "hidden",

                        flexWrap: {
                            xs: "nowrap",
                            sm: "initial",
                        },

                        scrollSnapType: {
                            xs: "x mandatory",
                            sm: "none",
                        },

                        WebkitOverflowScrolling: "touch",

                        // Não deixa a página inteira criar scroll horizontal
                        overscrollBehaviorX: "contain",

                        // Esconde scrollbar
                        scrollbarWidth: "none",

                        "&::-webkit-scrollbar": {
                            display: "none",
                        },
                    }}
                >
                    {planos.map((plano) => (
                        <Box
                            key={plano.tipo}
                            sx={{
                                position: "relative",

                                display: "flex",
                                flexDirection: "column",

                                // MOBILE
                                flex: {
                                    xs: "0 0 calc(100% - 45px)",
                                    sm: "initial",
                                },

                                width: {
                                    xs: "calc(100% - 45px)",
                                    sm: "auto",
                                },

                                minWidth: {
                                    xs: "calc(100% - 45px)",
                                    sm: 0,
                                },

                                maxWidth: {
                                    xs: "calc(100% - 45px)",
                                    sm: "none",
                                },

                                scrollSnapAlign: {
                                    xs: "start",
                                    sm: "none",
                                },

                                minHeight: {
                                    xs: "auto",
                                    lg: "285px",
                                },

                                p: {
                                    xs: 2.5,
                                    md: 2,
                                },

                                pt: {
                                    xs: 2.5,
                                    md: 2,
                                },

                                borderRadius: "10px",

                                border: plano.destaque
                                    ? "1px solid #1EFF86"
                                    : "1px solid #303541",

                                backgroundColor: plano.destaque
                                    ? "#112C27"
                                    : "#222631",

                                transition: "all 0.25s ease",

                                "&:hover": {
                                    transform: {
                                        xs: "none",
                                        md: "translateY(-4px)",
                                    },

                                    borderColor: "#1EFF86",

                                    boxShadow:
                                        "0 15px 35px rgba(0, 0, 0, 0.25)",
                                },
                            }}
                        >
                            {/* Badge */}
                            {plano.destaque && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '0',
                                        left: '20px',
                                        px: 1.5,
                                        py: 0.4,
                                        borderRadius: '20px',
                                        backgroundColor: '#1EFF86',
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: '8px',
                                            fontWeight: 900,
                                            letterSpacing: '1.5px',
                                            color: '#071A13',
                                        }}
                                    >
                                        MAIS ESCOLHIDO
                                    </Typography>
                                </Box>
                            )}

                            {/* Tipo */}
                            <Typography
                                sx={{
                                    fontSize: '8px',
                                    fontWeight: 700,
                                    letterSpacing: '2px',
                                    color: '#6B7280',
                                    marginTop: 1,
                                    mb: 0.5,
                                }}
                            >
                                {plano.tipo}
                            </Typography>

                            {/* Faturamento */}
                            <Typography
                                sx={{
                                    fontSize: {
                                        xs: '18px',
                                        md: '17px',
                                    },
                                    lineHeight: 1.1,
                                    fontWeight: 800,
                                    color: '#FFFFFF',
                                }}
                            >
                                {plano.faturamento}
                            </Typography>

                            {/* Descrição */}
                            <Typography
                                sx={{
                                    fontSize: '11px',
                                    color: '#9CA3AF',
                                    mt: 0.3,
                                }}
                            >
                                {plano.descricao}
                            </Typography>

                            {/* Preço */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'baseline',
                                    gap: 1,
                                    mt: 1.5,
                                    mb: 1.5,
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        fontWeight: 700,
                                        color: '#FFFFFF',
                                    }}
                                >
                                    R$
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: '24px',
                                        lineHeight: 1,
                                        fontWeight: 800,
                                        color: '#FFFFFF',
                                    }}
                                >
                                    {plano.preco}
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: '12px',
                                        color: '#9CA3AF',
                                    }}
                                >
                                    /mês
                                </Typography>
                            </Box>

                            {/* Benefícios */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 0.8,
                                    flex: 1,
                                }}
                            >
                                {plano.beneficios.map((beneficio, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: 1,
                                        }}
                                    >
                                        <Typography
                                            component="span"
                                            sx={{
                                                color: '#1EFF86',
                                                fontSize: '11px',
                                                lineHeight: 1.5,
                                            }}
                                        >
                                            ✓
                                        </Typography>

                                        <Typography
                                            sx={{
                                                fontSize: '12px',
                                                lineHeight: 1.35,
                                                color: '#AEB3BE',
                                            }}
                                        >
                                            {beneficio}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>

                            {/* Botão */}
                            <Button
                                fullWidth
                                sx={{
                                    mt: 2,
                                    minHeight: '36px',
                                    borderRadius: '20px',
                                    textTransform: 'none',
                                    fontSize: '11px',
                                    fontWeight: 800,
                                    color: plano.destaque
                                        ? '#071A13'
                                        : '#FFFFFF',
                                    backgroundColor: plano.destaque
                                        ? '#1EFF86'
                                        : 'transparent',
                                    border: plano.destaque
                                        ? '1px solid #1EFF86'
                                        : '1px solid #3B4352',

                                    '&:hover': {
                                        backgroundColor: plano.destaque
                                            ? '#14E878'
                                            : 'rgba(255,255,255,0.05)',
                                    },
                                }}
                                onClick={() => HandleChoosePlan(plano.id, plano.title, plano.descricao, plano.preco)}
                            >
                                Assinar {plano.tipo.charAt(0) +
                                    plano.tipo.slice(1).toLowerCase()}
                            </Button>
                        </Box>
                    ))}
                </Box>

                {/* Rodapé */}
                <Typography
                    sx={{
                        mt: 2.5,
                        fontSize: '12px',
                        color: '#6B7280',
                    }}
                >
                    Todos os planos incluem abertura de empresa e emissor de
                    nota fiscal. Sem fidelidade, sem taxa de adesão.
                </Typography>
            </Box>
        </Box>
    );
}
